import React, { useState } from "react";
import { submitForm } from "../../services/formService";

const MachineSalesForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    location: "",
    businessExperience: "",
    startingCapital: "",
    creditScore: "",
    lead_status: "Purchase Machine",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await submitForm("machine", formData);
    alert(result.message);
    if (result.success) {
      setFormData({
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        location: "",
        businessExperience: "",
        startingCapital: "",
        creditScore: "",
        lead_status: "Purchase Machine",
      });
    }
  };

  return (
    <form className="space-y-4" onSubmit={handleSubmit}>
      {/* Personal Information Section */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <input
          type="text"
          name="firstName"
          placeholder="First Name *"
          value={formData.firstName}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary"
          required
        />
        <input
          type="text"
          name="lastName"
          placeholder="Last Name *"
          value={formData.lastName}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary"
          required
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <input
          type="tel"
          name="phone"
          placeholder="Phone Number *"
          value={formData.phone}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary"
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Email Address *"
          value={formData.email}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary"
          required
        />
      </div>

      <input
        type="text"
        name="location"
        placeholder="City, State, or Zip Code *"
        value={formData.location}
        onChange={handleChange}
        className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary"
        required
      />

      {/* Business-Related Questions */}
      <div>
        <label className="block text-gray-700 font-medium mb-1">
          Have you operated a business before? *
        </label>
        <div className="flex gap-4">
          <label className="flex items-center gap-1">
            <input
              type="radio"
              name="businessExperience"
              value="Yes"
              checked={formData.businessExperience === "Yes"}
              onChange={handleChange}
              className="w-4 h-4 accent-primary"
            />
            Yes
          </label>
          <label className="flex items-center gap-1">
            <input
              type="radio"
              name="businessExperience"
              value="No"
              checked={formData.businessExperience === "No"}
              onChange={handleChange}
              className="w-4 h-4 accent-primary"
            />
            No
          </label>
        </div>
      </div>

      <div>
        <label className="block text-gray-700 font-medium mb-1">
          Starting Capital or Liquid Funds *
        </label>
        <select
          name="startingCapital"
          value={formData.startingCapital}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary"
          required
        >
          <option value="">Select an amount</option>
          <option value="$0-$9,999">$0 - $9,999</option>
          <option value="$10,000-$19,999">$10,000 - $19,999</option>
          <option value="$20,000-$29,999">$20,000 - $29,999</option>
          <option value="$30,000-$49,999">$30,000 - $49,999</option>
          <option value="$50,000+">$50,000+</option>
        </select>
      </div>

      <div>
        <label className="block text-gray-700 font-medium mb-1">
          What is your credit score? *
        </label>
        <select
          name="creditScore"
          value={formData.creditScore}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-primary"
          required
        >
          <option value="">Select your credit score range</option>
          <option value="300-579">300-579 (Poor)</option>
          <option value="580-669">580-669 (Fair)</option>
          <option value="670-739">670-739 (Good)</option>
          <option value="740-799">740-799 (Very Good)</option>
          <option value="800+">800+ (Excellent)</option>
        </select>
      </div>

      {/* Submit Button */}
      <button
        type="submit"
        className="w-full bg-primary text-white py-2 rounded shadow transition-transform duration-300 ease-in-out hover:font-bold"
      >
        Submit Inquiry
      </button>
    </form>
  );
};

export default MachineSalesForm;
